import { Directive, computed, input } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { injectCustomClassSettable } from '@spartan-ng/brain/core';
import { BrnDialogOverlay } from '@spartan-ng/brain/dialog';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';
import { pipe, tap } from 'rxjs';

export const hlmDialogOverlayClass = hlm(
    'isolate bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0'
);

@Directive({
    hostDirectives: [BrnDialogOverlay],
    selector: '[hlmDialogOverlay],hlm-dialog-overlay',
})
export class HlmDialogOverlay {
    private readonly _classSettable = injectCustomClassSettable({ host: true, optional: true });

    public readonly userClass = input<ClassValue>('', { alias: 'class' });

    private readonly _computedClass = computed(() => hlm(hlmDialogOverlayClass, this.userClass()));

    // Pushes the merged class through the brain classSettable host-directive API - not template-bindable,
    // so it is driven reactively via rxMethod (cleanup is tied to this directive's injection context).
    private readonly _applyClass = rxMethod<string>(
        pipe(tap((newClass) => this._classSettable?.setClassToCustomElement(newClass)))
    );

    constructor() {
        this._applyClass(this._computedClass);
    }
}
